module.exports = __webpack_public_path__ + "img/noCoupons.f2952b44.png";